import { ReactElement, useMemo } from 'react'
import { CompetenceProps, CompetencesTabProps } from './props'
import { Grid } from '../../../../Molecules'
import { SVGByName, Text } from '../../../../Atoms'

const Competence = ({ content, icon, title }: CompetenceProps) => (
    <Grid
        key={title}
        css={{
            justifyContent: 'start',

            '@desktop': { gap: '$3' },
            '@mobile': { gap: 0 },
        }}
        autoFlow={{ '@desktop': 'column' }}
    >
        <SVGByName name={icon} css={{ fontSize: 32, maxSize: 32, w: '100%' }} />
        <Grid>
            <Text bold css={{ color: 'neutral800' }}>
                {title}
            </Text>
            <Text css={{ color: 'neutral700' }}>{content}</Text>
        </Grid>
    </Grid>
)

const CompetencesTab = ({ competences }: CompetencesTabProps): ReactElement => {
    const competencesComponent = useMemo(
        () => competences && competences.map(Competence),
        [competences]
    )

    return (
        <Grid
            gap="16"
            data-cy="modalCompetenceTab"
            css={{
                '@desktop': {
                    alignItems: 'start',
                    gridAutoFlow: 'dense',
                    gridTemplateColumns: 'repeat(2, 1fr)',
                },
            }}
        >
            {competencesComponent}
        </Grid>
    )
}

export default CompetencesTab
